import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-empty-list',
    templateUrl: './empty-list.component.html',
    styleUrls: ['./empty-list.component.css']
})
export class EmptyListComponent implements OnInit {
    @Input() list: any[]; // required
    public message = 'La ricerca non ha prodotto risultati.';
    get visible(): boolean {
        return this.list && this.list.length === 0;
    }

    constructor() {}

    ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/empty-list/empty-list.component.ts